import "../../assets/css/order-total.css";
import { Say } from "../../languages";
import { Product } from "../../types";

type OrderTotalProps = {
  products: Product[];
  totalDefault: number;
  disabled?: boolean;
  className?: string;
};

export function OrderTotal(props: OrderTotalProps) {
  const { products, className = "", disabled = false, totalDefault = 39 } = props;
  const disabledClass = disabled ? "disabled" : "";
  const addTotal = (allTotal, itemTotal, qty) => +allTotal + +itemTotal * (+qty || 1);
  const total = !products.length
    ? totalDefault
    : products.reduce(
        (totalAll, { price, quantity = 1 }) => addTotal(totalAll, price, quantity),
        0
      ) || totalDefault;

  return (
    <div className={`order-total ${className} ${disabledClass}`}>
      <span className="order-total__label">
        <Say phrase="chosen.submission.total_label" />
      </span>
      <span className="order-total__content">
        <span className="order-total__amount">${total}</span> /{" "}
        <span className="order-total__frequency">
          <Say phrase="chosen.submission.total_frequency" />
        </span>
      </span>
    </div>
  );
}

export default OrderTotal;
